import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Fade, FadeScale } from 'ui/transitions';
import { skin, OemProps } from 'ui/styles/skin';

import './modal.css';

export type OwnProps = {
    id: string;
    visible: boolean;
};

const rawModal = (id: string) =>
    <T extends OwnProps>(Target: React.ComponentType<T>) =>
        class Modal extends React.Component<T & OemProps, {}> {
            static displayName = `modal(${Target.displayName || Target.name || '?'})`;

            modalRoot: HTMLElement | null;

            constructor(props: T & OemProps) {
                super(props);
                this.modalRoot = document.getElementById('modal-root');
            }

            render() {
                if (!this.modalRoot) {
                    return null;
                }
                const { visible, styles } = this.props;
                return ReactDOM.createPortal(
                    <Fade
                        visible={ visible }
                        duration={ 200 }
                        className="modal-host"
                    >
                        <div className="modal-background"/>
                        <FadeScale
                            visible={ visible }
                            duration={ 200 }
                            className="modal-container"
                            unmountOnExit={ true }
                        >
                            <div
                                id={ id }
                                className="modal"
                                style={ styles.Workspace }
                            >
                                <Target { ...this.props }/>
                            </div>
                        </FadeScale>
                    </Fade>,
                    this.modalRoot
                );
            }
        }
;

// Our modal requires skinning, so wrap rawModal in the skin HOC
export const modal =
    (id: string) =>
        <T extends OwnProps>(Target: React.ComponentType<T>) =>
            skin(rawModal(id)(Target));



// WEBPACK FOOTER //
// ./src/ui/shared/modal.tsx